<template>
	<tool-tip
			:text="text"
			content-class="top"
			custom-class="question"
			:position="{ top: 'top' }"
	>
		<svg-sprite icon-id="CircleQuestion" width="20" height="20"></svg-sprite>
	</tool-tip>
</template>
<script>
import ToolTip from "@/shared/ToolTip/ToolTip.vue";
export default {
	name: "ToolTipQuestion",
	components: { ToolTip },
	props: {
		text: String,
	}
};
</script>
<style scoped lang="scss">
.tooltipDropDown {
	line-height: 0;
	display: block;
	margin-left: 0;
	svg {
		cursor: help;
		color: #a3a3a3;
	}
}
</style>
